import { createContext, useContext } from 'react';
import type { AuthState } from './auth-reducer';

export interface AuthContextValue extends AuthState {
  /** Resolves true when the operator is signed in, false when the attempt
   * failed. The failure message lands on `error`; the password never
   * leaves the sign-in form. */
  signIn: (email: string, password: string) => Promise<boolean>;
  signOut: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return context;
}
